import React, { useEffect, useState } from 'react';
import FieldError from './helpers/FieldError';
import HelpText from './helpers/HelpText';
import i18n from '../../../i18n';
const Select = ({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = false,
  allowBlank = false,
  nullLabel = null,
  value = '',
  errors = [],
  helpText = '',
  selectAddUrl = '',
  selectUrl = '',
  createAttribute = '', 
  disabled = false,
  parent = '',
  style = {},
  options = [],
  many = false,
  onChange = () => {},
  pk = null
}) => {
    const [inputValue, setInputValue] = useState(value);
    const localOnChange = (e) => {
        setInputValue(e.target.value)
        onChange({'name':fieldName, 'value': e.target.value, 'label': options.find(o => o.id.toString() === e.target.value.toString())?.label})
    }
    useEffect(() => {
        setInputValue(value)
    }, [value])

    return (
    // <div
    //   id={`wrapper-${fieldName}`}
    //   className={`form-group ${wrapperClass} ${selectAddUrl ? 'select-add' : ''} ${errors.length > 0 ? 'is-invalid' : ''} ${style.inputType === 'hidden' ? 'd-none' : ''}`}
    // >        
    //     {label && (
    //         <label className={`w-100 col-form-label ${hideLabel ? 'sr-only' : ''}`}>
    //         {label} {!allowNull && '*'}
    //         </label>
    //     )}
        <select
            id={pk ? pk + '_' + fieldName : fieldName}
            multiple={many}
            className={`${style.class} form-select form-control ${errors.length > 0 ? 'is-invalid' : ''}`}
            name={fieldName}
            data-null={allowNull || allowBlank ? 'true' : undefined}
            data-selecturl={selectUrl || undefined}
            data-createattribute={createAttribute || undefined}
            data-url={ selectAddUrl ? selectAddUrl: undefined}
            data-urlget={ style.get ? style.get : ''}
            data-select_parent={parent || undefined}
            onChange={localOnChange}
            disabled={disabled}
            value={inputValue}
        >
            {(!inputValue && !allowNull) && 
            <option 
                key={"no_option"}
                value=''
            >
                {i18n.t('Select an option')}
            </option>
            }
            {(allowNull) && 
            <option
                key={"no_option"}
                value=''
            >
                {nullLabel || style.placeholder || i18n.t('-')}
            </option>
            }
            {options.map((option, index) => {   
                if (option.startOptionGroup) {
                    return <optgroup label={option.label} key={`group-${index}`}></optgroup>;
                } else if (option.endOptionGroup) {
                    return <optgroup key={`end-group-${index}`}></optgroup>;
                } else {
                    return (
                    <option
                        key={index}
                        value={option.id}
                        disabled={option.disabled}
                    >
                        {option.label}
                    </option>
                    );
                }
            })}
            {options.length === 0 ? <option value="" disabled={true}>{nullLabel ||i18n.t('No options')}</option> : null}
        </select>
    //     {errors ? errors.map( (error, index) => <FieldError key={index} error={error}/>) : null }
    //     <HelpText helpText={helpText}/>
    // </div>
  );
};

export default Select;
